import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createFormStep = (formStep) => {
    return vdkEmHappinessPortalApi.post('/form-steps/create', formStep);
};
const updateFormStep = (formStep) => {
    return vdkEmHappinessPortalApi.put('/form-steps', formStep);
};
const deleteFormStep = (id) => {
    return vdkEmHappinessPortalApi.delete(`/form-steps/${id}`);
};
const getFormStepById = (id) => {
    return vdkEmHappinessPortalApi.get(`/form-steps/${id}`);
};
const getFormStepsByEventId = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/form-steps-by-event-id/${eventId}`);
};
const formStepsAPI = {
    createFormStep,
    updateFormStep,
    deleteFormStep,
    getFormStepById,
    getFormStepsByEventId
};
export default formStepsAPI;
